/** Default-Text-Key-Suffix für die Abteilung-II-Würdigung, je nachdem ob die Tabelle Einträge hat. */
export function registerAbteilungIIAppreciationKeySuffix(hasEntries: boolean): string {
    return hasEntries ? "_nonempty_variant" : "_empty_variant";
}
